import { useState, useEffect, useContext } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { AppRoutesUI } from "../config/appRoutes";
import { RedirectUnauthorized } from "../utils/authRedirectHandlers";
import { CategoryContextProvider } from "../core/context/categoryContextProvider";
import { CountryRegionContextProvider } from "../core/context/countryRegionContextProvider";
import { FormContextProvider } from "../core/context/formContextProvider";
import { RegulationContextProvider } from "../core/context/regulationContextProvider";
import { Sidenav, Container, Header, Content, Sidebar } from "rsuite";

import { NotificationContext } from "../core/context/notificationContextProvider";
import NotificationComponent from "../Components/generic/notification/notification.component";
import TopNav from "../Components/generic/topNav/topNav.component";
import SideNav from "../Components/generic/sideNav/sideNav.component";
import SideDrawer from "../Components/generic/sideDrawer/sideDrawer.component";
import HomePage from "../pages/home/homePage";
import Category from "../pages/category/category";
import CountryRegion from "../pages/countryRegion/countryRegion";
import ContentUpload from "../pages/contentUpload/contentUpload";
import Forms from "../pages/forms/forms";
import Regulations from "../pages/regulations/regulations";
import { notificationContextTypes } from "../utils/typeDefs";
import NewsAggregator from "../pages/NewsAggregator/newsAggregator";
import MLIDataPage from "../pages/MLIData/MLIDataPage";
import PillarTwoNewsMapper from "../pages/PillarTwoNewsMapper/pillarTwoNewsMapper";

export const PrivateLayout = () => {
  const [expanded, setExpanded] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [windowHeight, setWindowHeight] = useState(window.innerHeight);

  const { handleNotificationClose, notificationShow, success, message } =
    useContext(NotificationContext) as notificationContextTypes;

  const handleSideNav = () => {
    setExpanded(!expanded);
  };

  const handleWindowSize = () => {
    setWindowWidth(window.innerWidth);
    setWindowHeight(window.innerHeight);
  };

  useEffect(() => {
    window.addEventListener("resize", handleWindowSize);

    return () => {
      window.removeEventListener("resize", handleWindowSize);
    };
  }, []);

  return (
    <RedirectUnauthorized>
      <Container>
        <Header>
          <TopNav handleSideNav={handleSideNav} />
        </Header>

        <NotificationComponent
          success={success}
          notificationShow={notificationShow}
          handleNotificationClose={handleNotificationClose}
          message={message}
        />

        <Container>
          {windowWidth >= 1200 ? (
            <Sidebar>
              <Sidenav expanded={true} className="sidenav-wrapper">
                <SideNav />
              </Sidenav>
            </Sidebar>
          ) : (
            <SideDrawer expanded={expanded} handleSideNav={handleSideNav} />
          )}
          <Content className="p-4">
            <Routes>
              <Route
                path={AppRoutesUI.Home.Route}
                element={<HomePage title="Welcome to WTA Publisher" />}
              />

              <Route
                path={AppRoutesUI.Category.Route}
                element={
                  <CategoryContextProvider>
                    <Category title="Manage Categories and Sub-Categories" />
                  </CategoryContextProvider>
                }
              />
              <Route
                path={AppRoutesUI.CountryRegion.Route}
                element={
                  <CountryRegionContextProvider>
                    <CountryRegion title="Manage Regions and Countries" />
                  </CountryRegionContextProvider>
                }
              />

              <Route
                path={AppRoutesUI.ContentUpload.Route + "/*"}
                element={
                  <ContentUpload
                    windowHeight={windowHeight}
                    windowWidth={windowWidth}
                    title="Upload Content for Country:"
                  />
                }
              />
              <Route
                path={AppRoutesUI.Forms.Route}
                element={
                  <FormContextProvider>
                    <Forms title="Publish Forms" />
                  </FormContextProvider>
                }
              />
              <Route
                path={AppRoutesUI.Regulations.Route}
                element={
                  <RegulationContextProvider>
                    <Regulations title="Publish Regulations" />
                  </RegulationContextProvider>
                }
              />
              <Route
                path={AppRoutesUI.NewsAggregator.Route}
                element={
                    <NewsAggregator></NewsAggregator>
                }
              />
              <Route
                path={AppRoutesUI.MLIDataUploader.Route}
                element={
                    <MLIDataPage title="MLI Data Uploader"></MLIDataPage>
                }
              />
              <Route
                path={AppRoutesUI.PillarTwoNewsMapper.Route}
                element={
                    <PillarTwoNewsMapper title="Pillar Two News Mapper"></PillarTwoNewsMapper>
                }
              />
              <Route
                path="/*"
                element={<Navigate to={AppRoutesUI.NotFound.Path()} replace />}
              />
            </Routes>
          </Content>
        </Container>
      </Container>
    </RedirectUnauthorized>
  );
};
